export const BKN_3DS_STATUS = {
  DS2: {
    CHALLENGE: 'CHALLENGE',
    BKN301CHALLENGE: 'BKN301CHALLENGE',
  },
};
